import React, { useState } from 'react';
import clinicService from '../../../../../services/clinic.service';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
function AddCustomization({ onAdded, onCancel }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();
    const { clinicId } = useParams();

    const onSubmit = (data) => {
        setIsSubmitting(true);
        const newData = [data];

        clinicService
            .updateCustomization(clinicId, newData)
            .then((res) => {
                onAdded?.(res.data);
                toast.success('Customization added', { position: toast.POSITION.BOTTOM_RIGHT });
                reset();
                onCancel?.();
            })
            .catch(() => {
                toast.error('Error adding customization', { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <div className="clinic-customization-add-form">
            <div className="notifications-form-label mb-3">
                <i className="bi bi-plus-circle me-1"></i>
                New Customization Option
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                    <label htmlFor="optionKey" className="notifications-form-label">
                        Key <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        id="optionKey"
                        className={`form-control form-control-sm ${errors.optionKey ? 'is-invalid' : ''}`}
                        placeholder="e.g. theme_color"
                        disabled={isSubmitting}
                        {...register('optionKey', { required: 'Key is required' })}
                    />
                    {errors.optionKey && <div className="invalid-feedback">{errors.optionKey.message}</div>}
                </div>

                <div className="mb-3">
                    <label htmlFor="optionValue" className="notifications-form-label">
                        Value <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        id="optionValue"
                        className={`form-control form-control-sm ${errors.optionValue ? 'is-invalid' : ''}`}
                        placeholder="e.g. #012970"
                        disabled={isSubmitting}
                        {...register('optionValue', { required: 'Value is required' })}
                    />
                    {errors.optionValue && <div className="invalid-feedback">{errors.optionValue.message}</div>}
                </div>

                <div className="clinic-customization-form-actions mt-0 pt-0 border-0">
                    {onCancel && (
                        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onCancel} disabled={isSubmitting}>
                            Cancel
                        </button>
                    )}
                    <button type="submit" className="btn btn-success btn-sm" disabled={isSubmitting}>
                        {isSubmitting ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                Saving…
                            </>
                        ) : (
                            <>
                                <i className="bi bi-floppy me-1"></i>
                                Save Option
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default AddCustomization;
